
const ReleaseNotes = [
  {
    title: "v0.9.18",
    description: "Version 0.9.18 is a maintenance release with bugfixes and improvements.",
    version: "0.9.18",
    features: [
      {
        title: "PDF Mapping",
        description: "Introduces PDF Mapping capabilities to map produced PDF files directly into fillable fields on a PDF document. This feature requires contacting support to enable and configure on a per-template basis.",
        icon: "mdi-file-pdf-box",
        feature: true,
        feature_desc: "Map produced PDF files into fillable fields on targeted PDF documents, allowing for more efficient and accurate data entry.",
        color: "blue"
      },
      {
        title: "Custom Reports",
        description: "Mapping requests and exports now operate under Custom Reports. These reports allow for more flexible data extraction and formatting options, enabling users to tailor their data exports to specific needs, such as into a specific format a third-party system requires. Custom Reports are designed by support on a per-organization basis.",
        icon: "mdi-file-chart",
        feature: true,
        feature_desc: "Streamline your data exports with Custom Reports, allowing tailored formats for third-party system integration.",
        color: "red"
      },
      {
        title: "Improved Session Management",
        description: "Enhancements to session handling for better security and user experience. This includes improved session timeout management, more robust session validation, and enhanced logging of session activities to help administrators monitor and manage user sessions more effectively.",
        icon: "mdi-account-clock",
        feature: true,
        feature_desc: "Enhanced security and user experience with improved session management features, including better cross-tab handling and session activity logging.",
        color: "green"
      },
    ],
    bugfixes: [
      {
        title: "Form Reminder Bugfixes",
        description: "We've addressed issues with Form Reminders to ensure they only target open cases. This fix prevents reminders from being sent for cases that have already been closed.",
        icon: "mdi-bug",
        feature: false,
        feature_desc: null,
        color: null
      },
    ]
  },
  {
    title: "v0.9.17",
    description: "Version 0.9.17 introduces Unknown SMS Pool, Message Source Filtering, Enhanced Access Logging, and Case Bulk Updates.",
    version: "0.9.17",
    features: [
      {
        title: "Unknown SMS Pool",
        description: "Added special handling for inbound SMS messages from unknown numbers. When an inbound SMS is received from a number that is not associated with any Contact in the system, the message will be logged in Organization settings. This allows administrators to review and manage these messages, and potentially add new Contacts or correct existing Contacts based on the incoming messages.",
        icon: "mdi-message-question",
        feature: true,
        feature_desc: "Introducing Unknown SMS Pool, allowing administrators to review inbound SMS messages from unknown numbers and manage them accordingly.",
        color: "green"
      },
      {
        title: "Message Source Filtering",
        description: "Added filtering by message source on the Contact Messages page. You can now filter messages based on their source, such as SMS, Email, or In-App Messages. This makes it easier to find and manage messages from specific channels.",
        icon: "mdi-message-settings",
        feature: true,
        feature_desc: "Introducing Message Source Filtering on the Contact Messages page, allowing you to filter messages based on their source (SMS, Email, In-App).",
        color: "blue"
      },
      {
        title: "Enhanced Access Logging",
        description: "Administrators can now view the IP address and user agent of users when viewing access logs. This additional information helps administrators monitor and audit user activity more effectively, providing insights into where and how users are accessing the system.",
        icon: "mdi-security",
        feature: true,
        feature_desc: "Administrators can now view more detailed information in access logs, including IP addresses and user agents of users accessing the system.",
        color: "#E64A19"
      },
      {
        title: "Case Bulk Updates",
        description: "Users can now perform bulk updates on Cases, allowing them to change the status (open/closed), case type (admin only), and Case Checklist item status for multiple Cases at once. This feature streamlines case management and saves time when making updates to multiple Cases.",
        icon: "mdi-select-multiple",
        feature: true,
        feature_desc: "Introducing Case Bulk Updates, allowing users to update status, case type, and checklist item status for multiple Cases simultaneously.",
        color: "#E64A19"
      }
    ],
    bugfixes: [
      {
        title: "Improved Contact Import Duplicate Handling",
        description: "We've improved the duplicate detection logic during Contact imports for phone numbers, and rejects an import if a duplicate is found within the import file itself. This helps to ensure data integrity and prevents accidental duplication of Contacts in your organization.",
        icon: "mdi-account-supervisor",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Improved Notification Rates and Bulk Messaging Performance",
        description: "We've made improvements to the notification sending rates and bulk messaging performance. This should result in faster delivery times for notifications and improved performance when sending bulk messages to large groups of Contacts.",
        icon: "speedometer",
        feature: false,
        feature_desc: null,
        color: null
      },
    ]
  },
  {
    title: "v0.9.16",
    description: "Version 0.9.16 introduces Case Progress, FAQ Articles, and Answer History on Form Review.",
    version: "0.9.16",
    features: [
      {
        title: "Case Progress",
        description: "Case Progress allows you to create a checklist of items to complete for each defined case type.\n\nCreate a case type with a checklist of items to complete, and when you create a new case of that type, the checklist will be automatically added to the case.\n\nTrack progress on each item, and you and your contacts can see an overview of progress on the case.",
        icon: "check_circle",
        feature: true,
        feature_desc: "Introducing Case Progress, allowing you to create checklists for different case types and allow your team and your Contacts to track progress on each item.",
        color: "green"
      },
      {
        title: "Case FAQ Articles",
        description: "FAQ Articles allow you to create a knowledge base of articles for your Contacts to view.\n\nYour Contacts can view the articles from the Contact Portal, helping to reduce support requests and provide valuable information.",
        icon: "help",
        feature: true,
        feature_desc: "Introducing FAQ Articles, allowing you to create a knowledge base of articles for your Contacts to view in the Contact Portal, reducing your team's support requests for repeated questions.",
        color: "blue"
      },
      {
        title: "Answer History now visible on Form Review",
        description: "When your team is reviewing a Contact's submitted form, you can now see the history of changes to each answer.\n\nClick on the history icon next to an answer to see a list of changes, including the date and time of the change, and the previous value.",
        icon: "history",
        feature: true,
        feature_desc: "Answer History is now visible when reviewing a Contact's submitted form, allowing your team to see the history of changes to each answer.",
        color: "orange"
      }
    ],
    bugfixes: [
      {
        title: "Improved Form Import Speed",
        description: "We've optimized the form import process for forms with many answer lists/tables. This optimization should significantly reduce the time it takes to import large forms with many fields.",
        icon: "speedometer",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Better SMS Keyword Matching",
        description: "We've updated the keyword matching for SMS replies to more accurately match system keywords used for SMS commands (e.g., START, STOP, HELP). This should reduce issues with Contacts not being able to successfully subscribe/unsubscribe from SMS notifications.",
        icon: "message_text",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Deprecating Fields",
        description: "The 'Soft Date' Field Type has been removed from the list of available field types when creating/editing questions. If you have existing forms with 'Soft Date' fields, they will continue to work as expected, but you will not be able to create new 'Soft Date' fields.\n\nAdditionally, the 'Number' Field Type has been renamed to 'Integer' to better reflect its purpose. Existing 'Number' fields will continue to function as before.",
        icon: "tune",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Various Bug Fixes and Improvements",
        description: "We've made various other bug fixes and improvements to enhance the overall stability and performance of the application.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.15 HOTFIX",
    description: "A hotfix to address a bug on Answer Lists",
    version: "0.9.15 HOTFIX",
    features: [],
    bugfixes: [
      {
        title: "Answer List Readonly Fix",
        description: "Fixed a visual bug that could cause Contacts confusion when completing forms and Answer Lists were set to readonly.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.15",
    description: "SMS Subscribe Handling, Channel Handling (SMS, Email, Push)",
    version: "0.9.15",
    features: [
      {
        title: "SMS Compliance Subscribe Handling",
        description: "Add SMS Subscription handling to comply with FCC regulations.\n\nContacts can now subscribe/unsubscribe from SMS notifications by replying with keywords (e.g., START, STOP, HELP).\n\nYour organization can manage SMS subscriptions from the admin panel.",
        icon: "message",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Channel Sending",
        description: "You can now specify the channel (SMS, Email, Push) when sending messages to Contacts. This allows for more flexibility in how you communicate with your Contacts based on their preferences and the nature of the message.",
        icon: "email",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.14",
    description: "Custom CLID on Reusable Fieldtypes, Bugfixes, Case Number Search, Improvements",
    version: "0.9.14",
    features: [
      {
        title: "Custom CLID on Reusable Fieldtypes",
        description: "Allow setting custom CLID on reusable fieldtypes. The CLID is used on import/export and API operations to uniquely identify the question & field you want to import data to.",
        icon: "label",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Case Number Search",
        description: "Added Case Number to the Contact Search page.",
        icon: "search",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "Number Field Error",
        description: "Fixed empty non-required number field error saying 'Number too large'.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.13",
    description: "Fixed bulk message throwing a 404 when CaseType not selected.",
    version: "0.9.13",
    features: [],
    bugfixes: [
      {
        title: "Bulk Message Bugfix",
        description: "Fixed bulk message throwing a 404 when CaseType not selected.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.12",
    description: "Movable Answer Lists, Deleting Non-Empty Answer Lists, Case Type Closing, Bugfixes, Filtering, Improvements",
    version: "0.9.12",
    features: [
      {
        title: "Movable Answer Lists",
        description: "Added ability for organization users to rearrange answer rows on a form.",
        icon: "list",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Case Type Closing",
        description: "Added ability to close case types.",
        icon: "lock",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "Refresh Race Condition",
        description: "Fixed refresh race condition for multiple tabs.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Case Type Closed Filtering",
        description: "Added case type closed filtering to reports.",
        icon: "filter",
        feature: false,
        feature_desc: null,
        color: null
      },
      {
        title: "Contact Page Improvement",
        description: "Added 'Has Installed App Before' to Contact page.",
        icon: "phone",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.11",
    description: "Certified Messages",
    version: "0.9.11",
    features: [
      {
        title: "Certified Messages",
        description: "Send secure messages that require your Contacts to log in to view them, and track read receipts so you know when your Contacts have viewed them.",
        icon: "certificate",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "Case Type Filtering",
        description: "Added Case Type filtering to Bulk Messaging.",
        icon: "filter",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.10",
    description: "Improvements, SMS Bounces, COC Download Option",
    version: "0.9.10",
    features: [
      {
        title: "Case Type List Search",
        description: "Added search to Case Type page.",
        icon: "search",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Esign Certificate Download Option",
        description: "Added option to bulk PDF downloading to download the COC/Audit Trail from esignatures.",
        icon: "file-download",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "SMS Bounces",
        description: "Added SMS Bounces to org admin, banner to contacts for SMS bounce error.",
        icon: "message-alert",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.09",
    description: "Improvements, Bugfixes, Domain Change Features, Access Logging, CSV Download",
    version: "0.9.09",
    features: [
      {
        title: "Access Logging",
        description: "Access Logging is now visible to administrators, allowing them to view what objects users have accessed.",
        icon: "account-search",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "CSV Message Download",
        description: "Added ability to download CSV of a contact's messages.",
        icon: "file-csv",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "Form Review - Comment Count Update",
        description: "Comment count now updates when comment is added.",
        icon: "comment",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.08",
    description: "Replace Package, Bugfixes, Case Type Search, SMS Login",
    version: "0.9.08",
    features: [
      {
        title: "Case Type Search",
        description: "Added Case Type Search on Reports and Form Search.",
        icon: "search",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "SMS Login",
        description: "Allow your Contacts to request a login token via SMS to log in to the Contact Portal without needing to remember a password.",
        icon: "message",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.07",
    description: "Updates to our signature provider, Esign Template Settings Redesign",
    version: "0.9.07",
    features: [
      {
        title: "Updated Signature Provider",
        description: "We've updated our partner's signature provider integration to the latest version, ensuring continued reliability and access to the latest features.",
        icon: "update",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Esign Template Settings",
        description: "We've updated the esign template settings page to improve usability and make it easier to configure your esignature templates.",
        icon: "settings",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: [
      {
        title: "File Count Fix",
        description: "Fixed file count on news articles, removed download option for cover image file.",
        icon: "file",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.06",
    description: "Organization & Case News, Redesigns, Bugfixes",
    version: "0.9.06",
    features: [
      {
        title: "Organization & Case News",
        description: "Added organization and case news features, which allow you to post news articles to your organization or specific cases. \n\n Your Contacts can view the articles from the Contact Portal, helping to reduce support requests and provide valuable information.",
        icon: "newspaper",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
    ],
    bugfixes: []
  },
  {
    title: "v0.9.05",
    description: "Email bounce banners, validation, ignore email problems, header validation",
    version: "0.9.05",
    features: [
      {
        title: "Ignore Email Problems",
        description: "Administrators can now apply a one-time ignore to email blocks, allowing emails to be sent again without needing to contact support. This is useful if an email was blocked due to a temporary issue, such as a full inbox or a misconfigured spam filter.\n\nThis is a one-time exemption. If an email containues to bounce or the recipient reports as spam, the block will be reapplied and cannot be released.",
        icon: "email",
        feature: true,
        feature_desc: null,
        color: "blue"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.04",
    description: "Header validation, API tokens, Webhooks",
    version: "0.9.04",
    features: [
      {
        title: "API Tokens",
        description: "Added API tokens, allowing developers to build integrations with the application without relying on a standard username/password flow. These API tokens are defined at the user level, and can be used to authenticate API requests on behalf of that user.",
        icon: "key",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Webhooks",
        description: "Introducing Webhooks, allowing you to call an extenral URL when certain events occur in the system, such as form updates or new messages. This enables you to integrate with other systems and automate workflows based on these events.",
        icon: "webhook",
        feature: true,
        feature_desc: null,
        color: "green"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.03",
    description: "CaseLocker Sign, Search by Field, Field Selectors",
    version: "0.9.03",
    features: [
      {
        title: "CaseLocker Sign",
        description: "Introducing CaseLocker Sign, a free electronic signature solution built directly into the CaseLocker platform. With CaseLocker Sign, you can easily send documents for signature, track their status, and securely store signed documents all within the same system you use to manage your cases.\n\nCaseLocker Sign is designed to be user-friendly and efficient, allowing you to streamline your document signing process and reduce the time it takes to get important documents signed. Whether you're sending contracts, agreements, or other legal documents, CaseLocker Sign makes it easy to get them signed quickly and securely.",
        icon: "signature",
        feature: true,
        feature_desc: null,
        color: "blue"
      },
      {
        title: "Search by Field",
        description: "Added search by field to Cases, Contacts, and Contact Files.",
        icon: "search",
        feature: true,
        feature_desc: null,
        color: "green"
      },
      {
        title: "Field Selectors",
        description: "Added field selectors on all form parts.",
        icon: "select",
        feature: true,
        feature_desc: null,
        color: "orange"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.02",
    description: "Bugfixes, validation, tel:// links, redirect dialog, form file report, field selector",
    version: "0.9.02",
    features: [
      {
        title: "Form File Report",
        description: "Introduced Form File Reports, allowing you to generate a ZIP archive of all files uploaded to a specific form across your filtered forms. This is useful for quickly gathering all files related to a particular form without having to download them individually.",
        icon: "file-document",
        feature: true,
        feature_desc: null,
        color: "blue"
      }
    ],
    bugfixes: [
      {
        title: "Number & Currency Validation Bugfixes",
        description: "0 values would cause submission to fail validation.",
        icon: "bug",
        feature: false,
        feature_desc: null,
        color: null
      }
    ]
  },
  {
    title: "v0.9.01",
    description: "Cleanups, CSV Export, Contact File Reports, Bugfixes",
    version: "0.9.01",
    features: [
      {
        title: "CSV Export",
        description: "Added CSV Export for Contact Files Search.",
        icon: "file-csv",
        feature: true,
        feature_desc: null,
        color: "blue"
      }
    ],
    bugfixes: []
  },
  {
    title: "v0.9.00",
    description: "Information Headers",
    version: "0.9.00",
    features: [
      {
        title: "Information Headers",
        description: "Added Information Headers feature, allowing your organization to define custom headers that can be displayed on various Contact pages. These headers can be used to provide important information, announcements, or instructions to your Contacts when they access their portal.",
        icon: "information",
        feature: true,
        feature_desc: null,
        color: "blue"
      }
    ],
    bugfixes: []
  }
]



const GlobalAtomicFieldTypes = [
  { value: 'text', name: 'Text' },
  { value: 'ssn', name: 'Social Security Number' },
  { value: 'email', name: 'Email' },
  { value: 'textarea', name: 'Text Area' },
  { value: 'harddate', name: 'Hard Date (Dropdown)' },
  { value: 'dropdown', name: 'Dropdown' },
  { value: 'radio', name: 'Radio' },
  { value: 'checkbox', name: 'Checkbox' },
  { value: 'number', name: 'Integer' },
  { value: 'currency', name: 'Currency' },
  { value: 'file', name: 'File' },
  { value: 'altesign', name: 'Additional Signer' },
  { value: 'regex', name: 'Regular Expression' }
]

const GlobalWebhookEventTypes = [
  { value: 'userform', name: 'Form Update' },
  { value: 'to client', name: 'New Outbound Message' },
  { value: 'from client', name: 'New Inbound Message' },
  { value: 'contact file', name: 'New Contact File Upload' },
]

const GlobalRegexPatterns = [
  {
    name: 'US Zip Code',
    validation_message: 'Invalid ZIP Code (Must Be #####)',
    regex_pattern: '^[0-9]{5}?$',
    mask_pattern: '#####'
  },
  {
    name: 'US Phone Number (No Extensions) (###-###-####)',
    validation_message: 'Invalid Phone Number (Must Be ###-###-####); Extensions not accepted',
    regex_pattern: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
    mask_pattern: '###-###-####'
  },
  {
    name: 'Custom Pattern'
  }
]

const GlobalStatusStrings = [
  { value: 'new', name: 'New', icon: 'lock_open' },
  { value: 'client started', name: 'Client Started', icon: 'lock_open' },
  { value: 'client signing', name: 'Client Signing (on submission)', icon: 'mdi-signature-freehand', apionly: true },
  { value: 'client submitted', name: 'Client Submitted', icon: 'edit', apionly: true },
  { value: 'in house', name: 'Completing In-House', icon: 'edit' },
  { value: 'under review', name: 'Under Review', icon: 'rate_review' },
  { value: 'deficient', name: 'Deficient', icon: 'thumb_down' },
  { value: 'esign', name: 'Request E-Signature', icon: 'mdi-signature' },
  { value: 'esign declined', name: 'E-Signature Declined', icon: 'mdi-file-document-box-remove', apionly: true },
  { value: 'esign returned', name: 'E-Signature Returned', icon: 'mdi-signature-freehand', apionly: true },
  { value: 'complete', name: 'Complete', icon: 'lock' },
  { value: 'submitted', name: 'Submitted', icon: 'lock' },
  { value: 'not completing', name: 'Not Completing', icon: 'mdi-format-page-break' }
]

function TestAnswerEmpty (answer, fieldType) {
  var passed = true
  if (fieldType.atomic_type === "radio" || fieldType.atomic_type === "dropdown") {
    if (answer.option) {
      passed = false
    }
  } else if (fieldType.atomic_type === "checkbox") {
    if (answer.options && Object.keys(answer.options).length != 0) {
      passed = false
    }
  } else if (fieldType.atomic_type === "number") {
    if (answer.number || answer.number === 0) {
      passed = false
    }
  } else if (fieldType.atomic_type === "date") {
    if (answer.date) {
      passed = false
    }
  } else if (fieldType.atomic_type === "harddate") {
    if (answer.year || answer.month || answer.day) {
      passed = false
    }
  } else if (fieldType.atomic_type === "altesign") {
    if (answer.name || answer.email) {
      passed = false
    }
  } else if (fieldType.atomic_type === "file") {
    if (answer.file) {
      passed = false
    }
  } else {
    if (answer.text && answer.text) {
      passed = false
    }
  }
  return passed
}

function MeetsCondition (part, get_answer, parts) {
  if (part.section) {
    if (!MeetsCondition(parts[part.section], get_answer, parts))
      return false
  }

  if(!part.conditional_question_id) return true
  
  if (MeetsCondition(parts[part.conditional_question_id], get_answer, parts)) {
    var answer = get_answer(part.conditional_question_id, part.conditional_fieldtype_id)
    if(answer === undefined && part.conditional_value === ""){
      return true
    }
    if(answer) {
      if (answer.string == part.conditional_value)
        return true
      if (answer.string.includes("; ") && answer.string.split("; ").includes(part.conditional_value)) {
        return true
      }
    }
  }
  return false
}

export default {
  AtomicFieldTypes: GlobalAtomicFieldTypes,
  StatusStrings: GlobalStatusStrings,
  TestAnswerEmpty: TestAnswerEmpty,
  GlobalRegexPatterns: GlobalRegexPatterns,
  MeetsCondition: MeetsCondition,
  GlobalWebhookEventTypes: GlobalWebhookEventTypes,
  ReleaseNotes: ReleaseNotes
}
